<template>
<!--
On génère une grille à partir de n mots fournis en props
On affiche la grille directement

1. On trie la liste du mot le plus long au plus court
2. On place le premier horizontalement sur la grille
La suite à boucler
3. On choisit le mot suivant (i) et on teste s'il existe i-1 interactions libres possibles
sur la grilles.
  Si oui on place le mot
  Si non on répète à i-2 etc...


Conditions pour qu'une lettre sur la grille soit disponible à un croisement :
1. Ne doit être ni suivie ni précédé sur l'axe testé.

Conditions pour qu'une case soit disponible selon un axe :
1. Ne doit pas être concomittente (sur l'axe perpendiculaire) à une lettre placée

Après chaque placement d'un mot sur la grille, on met à jour les index des lettres libres.
avalaibleLettres[
{
direction : 'vertical'
axeNumber:5,
number: 3,
pos: [2, 8, 10]
},
{
direction : 'horizontal'
axeNumber: 2,
number: 1,
pos: [6]},
},

]

Etape 3.
- On choisit l'axe avec le plus de lettres disponibles
- On regarde si le mot courrant contient ces lettres :
  NON : on boucle (test sur second meilleur axe)
  OUI : on regarde si l'espace entre les lettres correspond :
    NON : on boucle
    OUI : on vérifie pour chaque position si toutes les cellules sont disponibles sur cet axe
      NON : on boucle
      OUI : On place le mot en mettant à jour la grille et on met à jour les tableaux des index

-->


</template>

<script>
import {mapGetters} from "vuex";

export default {
name: "crossWords",
  props: {
    words: Array
  },

  created() {
    // On crée la liste triée des mots anglais
    this.englisWords = this.words.sort((a,b) => {
      return b.length - a.length
    });

    // On créé la grille en y plaçant le mot le plus long
    this.addGrid(this.words[0], 'horizontal', 0, 0)

    for(let i=0; i<this.words.length; i++) {
      if(i > 0) {
        let currentWord = this.words[i]
        let wordSet = false;
        // On cherche l'axe disponible le plus grand pouvant correspondre au mot
        for(let j=0; j< this.availableAxis.length; j++) {
          const startingCell = this.wordMatchesLetters(currentWord, this.availableAxis[j])
          if(startingCell !== false) {
            // On vérifie si les cellules vides qui vont abriter des lettres du mot
            // sont bien toutes disponibles
            if(this.wordMatchesFreeSpace(currentWord, this.availableAxis[j], startingCell)) {
              this.addGrid(currentWord, this.availableAxis[j].direction, startingCell, this.availableAxis[j].axeNumber)
              wordSet = true;
              break
            }
          }
        }
        if(!wordSet) {
          this.secondWords.push(currentWord)
        }
      }
    }

    for(let i=0; i<this.secondWords.length; i++) {
      let currentWord = this.secondWords[i]
      // On cherche l'axe disponible le plus grand pouvant correspondre au mot
      for(let j=0; j< this.availableAxis.length; j++) {
        const startingCell = this.wordMatchesLetters(currentWord, this.availableAxis[j])
        if(startingCell !== false) {
          // On vérifie si les cellules vides qui vont abriter des lettres du mot
          // sont bien toutes disponibles
          if(this.wordMatchesFreeSpace(currentWord, this.availableAxis[j], startingCell)) {
            this.addGrid(currentWord, this.availableAxis[j].direction, startingCell, this.availableAxis[j].axeNumber)
            break
          }
        }
      }
    }

    this.$emit('sendGrid', this.wordsGrid)
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },

  methods: {
    addGrid: function(word, axis, position, axisNumber) {
        this.growGrid(word, axis, position);
        if(position <0) {
          position = 0;
        }
        if(axis === 'horizontal') {
          // On parcours la ligne correspondante pour remplacer les cellules vides par les lettres
          // du mot à insérer
          const wordArray = word.split('')
          for(let horiPos=position; horiPos<word.length+position; horiPos++) {
            this.wordsGrid[axisNumber][horiPos] = wordArray[horiPos-position]
          }
        }

        else if(axis === 'vertical') {
          const wordArray = word.split('')
          for(let vertPos = position; vertPos < word.length+position; vertPos++) {
            this.wordsGrid[vertPos][axisNumber] = wordArray[vertPos-position]
          }
        }

        this.updateAvailableAxis()
    },

    growGrid: function(word, axis, position) {
      // On aggrandit la grille horizontalement si nécessaire
      if(axis === 'horizontal') {
        let newPosition = position
        if(position < 0) {
          // On ajoute des cellules vides devant chaque ligne
          for(let i=0; i<this.wordsGrid.length; i++) {
            let tempTab = []
            for (let j = 0; j< 0-position; j++) {
              tempTab.push('')
            }
            for(let cellIndex=0; cellIndex<tempTab.length; cellIndex++) {
              this.wordsGrid[i].unshift(tempTab[cellIndex])
            }
          }
          newPosition = 0;
        }
        if(word.length + newPosition> this.wordsGrid[0].length) {
          let columnsToAdd = (word.length + newPosition) - this.wordsGrid[0].length
          for(let i=0; i<this.wordsGrid.length; i++) {
            //const lineSize = this.wordsGrid.length
            for (let j = 0; j< columnsToAdd; j++) {
              this.wordsGrid[i].push('')
            }
          }
        }
      }

      // On aggrandit la grille verticalement si nécessaire
      else {
        let newPosition = position
        if(position < 0) {
          // On ajoute juste des lignes avant
          let horizontalTempTab = []
          for(let j=0; j<this.wordsGrid[0].length; j++) {
            horizontalTempTab.push('')
          }
          for(let i = 0; i< 0-position; i++) {
            this.wordsGrid.unshift(horizontalTempTab.slice())
          }
          newPosition = 0;
        }

        if(word.length + newPosition > this.wordsGrid.length) {
          // On ajoute juste des lignes après
          let rowsToAdd = (word.length+newPosition) - this.wordsGrid.length
          let horizontalTempTab = []
          for(let j=0; j<this.wordsGrid[0].length; j++) {
            horizontalTempTab.push('')
          }

          for(let i = 0; i < rowsToAdd; i++) {
            this.wordsGrid.push(horizontalTempTab.slice())
          }
        }
      }

    },

    updateAvailableAxis() {
      this.availableAxis = []
      // on parcours la grille par axes et on repère les axes remplissant les conditions
      // de validité,et on stocke les infos dans le tableau temporaire

      // On parcours les lignes
      for(let indexLine=0; indexLine<this.wordsGrid.length; indexLine++) {
        let currentLine = this.wordsGrid[indexLine]
        let letters = []

        // On parcours les cellules
        for(let indexColumn=0; indexColumn< this.wordsGrid[indexLine].length; indexColumn++) {
          let cell = this.wordsGrid[indexLine][indexColumn]
          if(cell !== '') {
            // Si on est sur une lettre, on vérifie les conditions de validités
            if(indexColumn === 0) {
              if(currentLine[1] === '') {
                letters.push({
                  letter: cell,
                  position: indexColumn
                })
              }
            }
            else if(indexColumn >= currentLine.length-1) {
              if(currentLine[currentLine.length-2] === '') {
                letters.push({
                  letter: cell,
                  position: indexColumn
                })
              }
            }
            else {
              if(currentLine[indexColumn-1] === '' && currentLine[indexColumn+1] === '') {
                letters.push({
                  letter: cell,
                  position: indexColumn
                })
              }
            }
          }
        }

        if(letters.length >0) {
          // tant qu'on peut enlever une lettre à l'extrémité, sans épuiser les lettres,
          // on ajoute des axes subsidiaires
          let tempLetters = letters.slice();
          let nbToRemove = 0
          do {
            this.availableAxis.push(
                {
                  direction : 'horizontal',
                  axeNumber: indexLine,
                  number: tempLetters.length,
                  letters: tempLetters
                }
            )
            nbToRemove++
            let removeLeft = nbToRemove;
            let removeRight = 0;
            // nbToRemove = removeLeft + removeRight
            while(removeRight <= nbToRemove) {
              this.availableAxis.push(
                  {
                    direction : 'horizontal',
                    axeNumber: indexLine,
                    number: tempLetters.slice().splice(-removeRight,removeRight).splice(0,removeLeft).length,
                    letters: tempLetters.slice().splice(-removeRight,removeRight).splice(0,removeLeft)
                  }
              )
              removeLeft--;
              removeRight++;
            }
          }
          while (tempLetters.length>=nbToRemove)

        }
      }
      // On parcours les colonnes
      for(let indexColumn = 0; indexColumn< this.wordsGrid[0].length; indexColumn++) {
        let letters = []
        // On parcourt les cellules (uniquement si on a au moins 2 lignes
        for(let indexLine = 0; indexLine < this.wordsGrid.length; indexLine++) {
          if(this.wordsGrid[indexLine][indexColumn] !== '') {
            // Si on est sur une lettre, on vérifie les conditions de validités
            if(this.wordsGrid.length === 1) {
              letters.push({
                letter: this.wordsGrid[indexLine][indexColumn],
                position: indexLine,
              })
            }
            else if(indexLine === 0) {
              if(this.wordsGrid[1][indexColumn] === '') {
                letters.push({
                  letter: this.wordsGrid[indexLine][indexColumn],
                  position: indexLine,
                })
              }
            }
            else if(indexLine > this.wordsGrid.length-2) {
              if(this.wordsGrid[indexLine-1][indexColumn] === '') {
                letters.push({
                  letter: this.wordsGrid[indexLine][indexColumn],
                  position: indexLine,
                })
              }
            }
            else if(this.wordsGrid[indexLine+1][indexColumn] === '' && this.wordsGrid[indexLine-1][indexColumn] === '') {
              letters.push({
                letter: this.wordsGrid[indexLine][indexColumn],
                position: indexLine,
              })
            }
          }
        }

        if(letters.length >0) {
          this.availableAxis.push(
              {
                direction : 'vertical',
                axeNumber: indexColumn,
                number: letters.length,
                letters: letters
              }
          )
          // tant qu'on peut enlever une lettre à l'extrémité, sans épuiser les lettres,
          // on ajoute des axes subsidiaires
          let tempLetters = letters.slice();
          let nbToRemove = 0
          do {
            this.availableAxis.push(
                {
                  direction : 'vertical',
                  axeNumber: indexColumn,
                  number: tempLetters.length,
                  letters: tempLetters
                }
            )
            nbToRemove++
            let removeLeft = nbToRemove;
            let removeRight = 0;
            // nbToRemove = removeLeft + removeRight
            while(removeRight <= nbToRemove) {

              this.availableAxis.push(
                  {
                    direction : 'vertical',
                    axeNumber: indexColumn,
                    number: tempLetters.slice().splice(-removeRight,removeRight).splice(0,removeLeft).length,
                    letters: tempLetters.slice().splice(-removeRight,removeRight).splice(0,removeLeft)
                  }
              )
              removeLeft--;
              removeRight++;
            }
          }
          while (tempLetters.length>=nbToRemove)

        }
      }

      this.availableAxis = this.availableAxis.sort((a,b) => {
        return b.number-a.number;
      }).filter(element => element.letters.length >0
      )
    },

    wordMatchesLetters(word, axis) {
      // Si une seule des lettres n'est pas contenue dans le mot,
      // on renvoie faux
      for(let i=0; i<axis.letters.length; i++) {
        if(!word.includes(axis.letters[i].letter)) {
          return false
        }
      }

      // On parcourt le mot jusqu'à la première correspondance
      for(let i=0; i<word.length; i++) {
        if(word.split('')[i] === axis.letters[0].letter) {
          // on parcours letters pour vérifier si le mot match en partant de
          // la première correspondance
          let check = true
          for(let index=0; index<axis.letters.length; index++) {
            let letter = axis.letters[index]
            if(index >0) {
              if(letter.letter !== word.split('')[i+(letter.position-axis.letters[0].position)]) {
                check = false
              }
            }
          }

          if(check) {
            return (axis.letters[0].position - i)
          }
          return false
        }
      }
    },

    wordMatchesFreeSpace(currentWord, axis, startingPosition) {
      // On vérifie s'il n'y a pas de lettres à côté du mot sur la grille
      // sauf aux positions de croisements
      if(axis.direction === 'horizontal') {
        // Si le mot est directement précédé ou suivi par une lettre,
        // on retourne faux
        if(startingPosition>0 && currentWord.length+startingPosition <this.wordsGrid[axis.axeNumber].length) {
          if(this.wordsGrid[axis.axeNumber][startingPosition-1] !== '' || this.wordsGrid[axis.axeNumber][currentWord.length+startingPosition] !== '') {
            return false
          }
        }
        else if(startingPosition<=0) {
          if(this.wordsGrid[axis.axeNumber][currentWord.length+startingPosition] !== '') {
            return false
          }
        }
        else {
          if(this.wordsGrid[axis.axeNumber][startingPosition-1] !== '') {
            return false
          }
        }

        for(let i=startingPosition; i<(currentWord.length +startingPosition); i++) {
          // On ne vérifie pas si la lettre est hors de la grille courante
          if(i>=0) {
            // on parcours l'axe sur la longueur du mot
            // ne ne vérifie pas l'es cellules adjacentes si on est sur une case de croisement
            let skipCheck = false
            if(i>=this.wordsGrid[0].length) {
              skipCheck = true
            }
            for(let j=0; j<axis.letters.length; j++) {
              let letter = axis.letters[j]
              if(letter.position === i) {
                skipCheck = true
              }
            }

            if(!skipCheck) {
              // Si la cellule est suivie ou précédée directement par 2 lettres,
              // on considère l'espace non valide
              let consLetters = 0;
              for(let letterIndex=1; letterIndex<= 2; letterIndex++) {
                if(this.wordsGrid[axis.axeNumber].length > (i+letterIndex)) {
                  if(this.wordsGrid[axis.axeNumber][i+letterIndex] !== '') {
                    consLetters++
                  }
                }
              }
              if(consLetters >=2) {
                return false
              }

              if(axis.axeNumber>0 && axis.axeNumber < this.wordsGrid.length-1) {
                if(this.wordsGrid[axis.axeNumber-1][i] !== '' || this.wordsGrid[axis.axeNumber+1][i] !== '') {
                  return false
                }
              }
              else if(axis.axeNumber<=0) {
                if(this.wordsGrid[axis.axeNumber+1][i] !== '') {
                  return false
                }
              }
              else if (axis.axeNumber >= this.wordsGrid.length-1) {
                if(this.wordsGrid[axis.axeNumber-1][i] !== '') {
                  return false
                }
              }
            }
          }
        }
        return true
      }

      else if(axis.direction === 'vertical') {

        if(this.wordsGrid.length >1) {
          // Si le mot est directement précédé ou suivi par une lettre,
          // on retourne faux
          if(startingPosition>0 && (currentWord.length+startingPosition) <(this.wordsGrid.length)) {
            if(this.wordsGrid[startingPosition-1][axis.axeNumber] !== '' || this.wordsGrid[(currentWord.length+startingPosition)][axis.axeNumber] !== '') {
              return false
            }
          }
          else if(startingPosition<=0 && (currentWord.length+startingPosition) <(this.wordsGrid.length)) {
            if(this.wordsGrid[currentWord.length+startingPosition][axis.axeNumber] !== '') {
              return false
            }
          }
          else {
            if(this.wordsGrid[startingPosition-1][axis.axeNumber] !== '') {
              return false
            }
          }

          for(let i=startingPosition; i<(currentWord.length +startingPosition); i++) {
            // on parcours l'axe sur la longueur du mot
            let skipCheck = false
            if(i<0 || i>= this.wordsGrid.length) {
              skipCheck = true
            }

            for(let j=0; j< axis.letters.length; j++) {
              let letter = axis.letters[j]
              if(letter.position === i) {
                skipCheck = true
              }
            }

            if(!skipCheck) {
              // Si la cellule est suivie directement par 2 lettres,
              // on considère l'espace non valide
              let consLetters = 0
              for(let letterIndex=1; letterIndex<= 2; letterIndex++) {
                if(this.wordsGrid.length > (axis.axeNumber+letterIndex)) {
                  if(this.wordsGrid[axis.axeNumber+letterIndex][i] !== '') {
                    consLetters++
                  }
                }
              }
              if(consLetters >=2) {
                return false
              }
              if(axis.axeNumber>0 && axis.axeNumber < this.wordsGrid[0].length-1) {
                if(this.wordsGrid[i][axis.axeNumber-1] !== '' || this.wordsGrid[i][axis.axeNumber+1] !== '') {
                  return false
                }
              }
              else if(axis.axeNumber<=0) {
                if(this.wordsGrid[i][axis.axeNumber+1] !== '') {
                  return false
                }
              }
              else if (axis.axeNumber >= this.wordsGrid[0].length-1) {
                if(this.wordsGrid[i][axis.axeNumber-1] !== '') {
                  return false
                }
              }
            }
          }
        }

        return true
      }
    }
  },

  data() {
    return {
      wordsGrid: [['']],
      availableAxis: [],
      englishWords: [],
      frenchWords: [],
      definitions: [],
      secondWords: []
    }
  }
}
</script>

<style scoped>

</style>